<template>
    <div :class="{ 'crud-contratos--embedded': embedded }">
      <template>
        <v-row justify="center">
          <v-dialog v-model="confirmDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span style="color: #d60000">{{ $t('system.alert') }}</span>
              </v-card-title>
              <v-card-text>
                <span style="color: #d60000">{{ this.mensagemdialog }}</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red accent-4"
                  class="white--text"
                  @click="confirmDialog = false"
                  >{{ this.messageDismissButton }}</v-btn
                >
                <v-btn
                  v-if="showConfirmButton"
                  color="red accent-4"
                  class="white--text"
                  @click="confirm"
                  >{{ this.messageConfirmButton }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <v-dialog v-model="dialog" max-width="100%">
                <v-card>
                  <v-card-title>
                    <span class="headline" style="color: #4a4a4a">{{ formTitle }}</span>
                  </v-card-title>
    
                  <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="formValidado">
                        <!-- Card 1: Dados Gerais -->
                        <v-card class="pa-4 mb-4" outlined>
                          <v-card-title class="text-h6 pa-0 mb-3 d-flex align-center justify-space-between">
                            <span>{{ $t('contract.sections.generalData') }}</span>
                            <div class="d-flex align-center">
                              <v-switch
                                v-if="!isContratoControle"
                                v-model="editedItem.padrao"
                                :label="$t('contract.defaultForReports')"
                                :hint="$t('contract.defaultForReportsHint')"
                                persistent-hint
                                :true-value="1"
                                :false-value="0"
                                :disabled="isFormReadonly"
                                class="mt-0 pt-0 mr-4"
                              ></v-switch>
                              <v-switch
                                v-model="editedItem.ativo"
                                :label="$t('contract.active')"
                                class="mt-0 pt-0"
                                hide-details
                                :disabled="isFormReadonly"
                              ></v-switch>
                            </div>
                          </v-card-title>
                          <v-divider class="mb-3"></v-divider>
                          <v-row>
                            <v-col cols="12" sm="6" md="3">
                              <v-text-field
                                v-model="editedItem.cod_contrato"
                                :label="$t('contract.contractCode')"
                                :rules="isFormReadonly ? [] : [(v) => (!!v && v.length <= 15) || $t('contract.messages.codeRequired')]"
                                :disabled="isFormReadonly || isCodigoDisabled"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                              <v-autocomplete
                                v-model="editedItem.id_cliente"
                                :items="clientes"
                                :label="editedIndex === -1 ? $t('contract.client') + ' *' : $t('contract.client')"
                                item-value="id_cliente"
                                item-text="nome_cliente"
                                :disabled="isFormReadonly || (shouldLockClienteOnCreate() && editedIndex === -1)"
                                :rules="clienteCreateRules"
                                :clearable="!isFormReadonly && editedIndex !== -1"
                                v-if=isContratoControle
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                              <v-autocomplete
                                v-model="editedItem.id_empresa"
                                :items="empresasPermitidas"
                                :label="$t('contract.company')"
                                item-value="id_empresa"
                                item-text="razao_social"
                                :disabled="isFormReadonly"
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="showContratoSubsidioUnidadesSelects && !isContratoControle">
                              <v-autocomplete
                                v-model="editedItem.id_unidades"
                                :items="unidades"
                                :label="$t('contract.unit')"
                                item-value="id_unidade"
                                item-text="descricao_unidade"
                                multiple
                                chips
                                :deletable-chips="!isFormReadonly"
                                :clearable="!isFormReadonly"
                                :disabled="isFormReadonly"
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="editedItem.descricao"
                                :label="$t('contract.description')"
                                :disabled="isFormReadonly"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card>

                        <!-- Card 2: Vigência e Classificação -->
                        <v-card class="pa-4 mb-4" outlined>
                          <v-card-title class="text-h6 pa-0 mb-3">
                            {{ $t('contract.sections.validityClassification') }}
                          </v-card-title>
                          <v-divider class="mb-3"></v-divider>
                          <v-row>
                            <v-col cols="12" sm="6" md="2">
                              <v-datetime-picker
                                :label="$t('contract.startValidity')"
                                v-model="dti"
                                :key="'dti-' + datePickerKey"
                                :time-picker-props="timeProps"
                                :text-field-props="textFieldPropsInicio"
                                time-format="HH:mm:ss"
                                date-format="dd/MM/yyyy"
                                :clear-text="$t('button.close')"
                                :disabled="isFormReadonly"
                              >
                                <template slot="dateIcon">
                                  <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                  <v-icon>mdi-clock</v-icon>
                                </template>
                              </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="6" md="2">
                              <v-datetime-picker
                                :label="$t('contract.endValidity')"
                                v-model="dtf"
                                :key="'dtf-' + datePickerKey"
                                :time-picker-props="timeProps"
                                :text-field-props="textFieldPropsFimComputed"
                                time-format="HH:mm:ss"
                                date-format="dd/MM/yyyy"
                                :clear-text="$t('button.close')"
                                :disabled="isFormReadonly"
                              >
                                <template slot="dateIcon">
                                  <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                  <v-icon>mdi-clock</v-icon>
                                </template>
                              </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="6" md="2" v-if="showContratoSubsidioUnidadesSelects">
                              <v-select
                                v-model="editedItem.tipo_contrato"
                                :items="tipoContratoItems"
                                :label="$t('contract.type')"
                                item-value="value"
                                item-text="text"
                                :disabled="isFormReadonly || editedIndex !== -1"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="showContratoSubsidioUnidadesSelects && !isContratoControle">
                              <v-autocomplete
                                v-model="editedItem.id_tipo_veiculo"
                                :items="tiposVeiculos"
                                :label="$t('contract.vehicleType')"
                                item-value="id_tipo_veiculo"
                                item-text="descricao_tipo_veiculo"
                                :disabled="isFormReadonly"
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" v-if="showContratoSubsidioUnidadesSelects && isContratoControle">
                              <v-autocomplete
                                v-model="editedItem.id_contratos_filhos"
                                :items="contratosOperacionaisElegiveis"
                                :label="$t('contract.childContracts')"
                                item-value="id_contrato"
                                :item-text="contratoFilhoLabel"
                                multiple
                                chips
                                :deletable-chips="!isFormReadonly"
                                :clearable="!isFormReadonly"
                                :disabled="isFormReadonly"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-card>

                        <!-- Card 3: Valores e Faturamento -->
                        <v-card class="pa-4 mb-4" outlined v-if="!isContratoControle">
                          <v-card-title class="text-h6 pa-0 mb-3">
                            {{ $t('contract.sections.valuesBilling') }}
                          </v-card-title>
                          <v-divider class="mb-3"></v-divider>
                          <v-row>
                            <v-col cols="12" sm="6" md="3">
                              <v-text-field
                                v-model="editedItem.valor_fixo"
                                :label="$t('contract.valueFixed')"
                                :prefix="$t('contract.currencyCipher') + ' ' "
                                type="number"
                                hide-spin-buttons
                                :clearable="!isFormReadonly && !calculoDaTarifa('id_tarifa_fixa')"
                                :disabled="isFormReadonly || !!calculoDaTarifa('id_tarifa_fixa')"
                                :hint="hintValorCalculado('id_tarifa_fixa')"
                                :persistent-hint="!!calculoDaTarifa('id_tarifa_fixa')"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="showContratoSubsidioTarifaSelect">
                              <v-select
                                v-model="editedItem.id_tarifa_fixa"
                                :items="tarifasFixas"
                                :label="$t('contract.tariffFixed')"
                                item-value="id_tarifa"
                                item-text="descricao_tarifa"
                                :clearable="!isFormReadonly"
                                :disabled="isFormReadonly"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                              <v-text-field
                                v-model="editedItem.valor_variavel"
                                :label="$t('contract.valueVariable')"
                                :prefix="$t('contract.currencyCipher') + ' ' "
                                type="number"
                                hide-spin-buttons
                                :clearable="!isFormReadonly && !calculoDaTarifa('id_tarifa')"
                                :disabled="isFormReadonly || !!calculoDaTarifa('id_tarifa')"
                                :hint="hintValorCalculado('id_tarifa')"
                                :persistent-hint="!!calculoDaTarifa('id_tarifa')"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="showContratoSubsidioTarifaSelect">
                              <v-select
                                v-model="editedItem.id_tarifa"
                                :items="tarifasVariaveis"
                                :label="$t('contract.tariffVariable')"
                                item-value="id_tarifa"
                                item-text="descricao_tarifa"
                                :clearable="!isFormReadonly"
                                :disabled="isFormReadonly"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                              <v-text-field
                                v-model="editedItem.valor_mao_de_obra"
                                :label="$t('contract.valueLabor')"
                                :prefix="$t('contract.currencyCipher') + ' ' "
                                type="number"
                                hide-spin-buttons
                                :clearable="!isFormReadonly && !calculoDaTarifa('id_tarifa_labor')"
                                :disabled="isFormReadonly || !!calculoDaTarifa('id_tarifa_labor')"
                                :hint="hintValorCalculado('id_tarifa_labor')"
                                :persistent-hint="!!calculoDaTarifa('id_tarifa_labor')"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" v-if="showContratoSubsidioTarifaSelect">
                              <v-select
                                v-model="editedItem.id_tarifa_labor"
                                :items="tarifasMaoDeObra"
                                :label="$t('contract.tariffLabor')"
                                item-value="id_tarifa"
                                item-text="descricao_tarifa"
                                :clearable="!isFormReadonly"
                                :disabled="isFormReadonly"
                              ></v-select>
                            </v-col>
                            <template v-if="showContratoSubsidioUnidadesSelects">
                              <v-col cols="12" sm="6" md="3">
                                <v-select
                                  v-model="editedItem.tipo_ciclo_pagamento"
                                  :items="tipoCicloPagamentoItems"
                                  :label="$t('contract.paymentCycle.type')"
                                  item-value="value"
                                  item-text="text"
                                  :disabled="isFormReadonly"
                                  @change="normalizeCicloPagamentoFields(editedItem)"
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="3" v-if="isCicloMensal">
                                <v-text-field
                                  v-model.number="editedItem.dia_ciclo_pagamento"
                                  :label="$t('contract.paymentCycle.closingDay')"
                                  type="number"
                                  min="1"
                                  max="28"
                                  hide-spin-buttons
                                  :clearable="!isFormReadonly"
                                  :disabled="isFormReadonly"
                                  :hint="$t('contract.paymentCycle.closingDayHint')"
                                  persistent-hint
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="3" v-if="isCicloDias">
                                <v-text-field
                                  v-model.number="editedItem.dias_ciclo_pagamento"
                                  :label="$t('contract.paymentCycle.dayCount')"
                                  type="number"
                                  min="1"
                                  max="366"
                                  hide-spin-buttons
                                  :rules="isFormReadonly ? [] : [(v) => (v != null && v !== '' && Number(v) >= 1 && Number(v) <= 366) || $t('contract.paymentCycle.dayCountRequired')]"
                                  :disabled="isFormReadonly"
                                  :hint="$t('contract.paymentCycle.dayCountHint')"
                                  persistent-hint
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="3" v-if="isCicloQuinzenal || isCicloDias">
                                <v-text-field
                                  v-model="editedItem.dt_referencia_ciclo"
                                  :label="$t('contract.paymentCycle.anchorDate')"
                                  type="date"
                                  :disabled="isFormReadonly"
                                  :hint="isCicloDias ? $t('contract.paymentCycle.anchorDateHintDays') : $t('contract.paymentCycle.anchorDateHint')"
                                  persistent-hint
                                ></v-text-field>
                              </v-col>
                            </template>
                          </v-row>
                        </v-card>

                        <!-- Card: fórmula de valor do contrato (motor de subsídio) -->
                        <v-card class="pa-4 mb-4" outlined v-if="showContratoSubsidioMotorCalculos">
                          <v-card-title class="text-h6 pa-0 mb-3">
                            {{ $t('subsidyMotorContract.calculations') }}
                          </v-card-title>
                          <v-divider class="mb-3"></v-divider>
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                v-model="editedItem.id_calculo"
                                :items="calculosValorCatalogo"
                                item-value="id_calculo"
                                :item-text="calculoCatalogoLabel"
                                :label="$t('subsidyMotorContract.calculations')"
                                :hint="$t('subsidyMotorContract.calculationsHint')"
                                persistent-hint
                                :clearable="!isFormReadonly"
                                :disabled="isFormReadonly"
                                @change="onCalculoContratoChange"
                              >
                                <template v-slot:item="{ item }">
                                  <v-list-item-content>
                                    <v-list-item-title>{{ calculoCatalogoLabel(item) }}</v-list-item-title>
                                  </v-list-item-content>
                                  <v-list-item-action v-if="isFinalidadeValor(item.finalidade)">
                                    <v-chip x-small color="primary" outlined>
                                      {{ $t('subsidyMotorCatalog.purposes.contractValue') }}
                                    </v-chip>
                                  </v-list-item-action>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <!-- Parâmetros do cálculo, por contrato: o mesmo cálculo
                                 rende valores diferentes em cada contrato. -->
                            <template v-for="calc in selectedCalculosWithParams">
                              <v-col
                                cols="12" sm="6" md="4"
                                v-for="key in calc.param_keys"
                                :key="calc.id_calculo + '-' + key"
                              >
                                <v-text-field
                                  v-model="calculosParametros[calc.id_calculo][key]"
                                  :label="calculoParamLabel(calc, key)"
                                  type="number"
                                  hide-spin-buttons
                                  :disabled="isFormReadonly"
                                ></v-text-field>
                              </v-col>
                            </template>
                            <v-col cols="12" v-if="calculoValorContratoAtivo">
                              <v-alert type="info" dense text class="mb-0">
                                {{ $t('contract.valueFromCalculation', { code: calculoValorContratoAtivo.codigo }) }}
                              </v-alert>
                            </v-col>

                          </v-row>
                        </v-card>

                        <!-- Campos específicos Rio / associação de linhas -->
                        <v-row v-if="showContratoSubsidioRioFields">
                          <v-col cols="12" sm="6" md="3">
                            <v-text-field
                              v-model="editedItem.tempo_limite_envio"
                              :label="$t('contract.sendTimeLimit')"
                              suffix=" s"
                              type="number"
                              hide-spin-buttons
                              :disabled="isFormReadonly"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-text-field
                              v-model="editedItem.porcentagem_posicoes_enviadas"
                              :label="$t('contract.minPercentagePositionsSent') + ' *'"
                              :rules="isFormReadonly ? [] : [(v) => (!!v && v > 0) || $t('contract.messages.fieldRequiredGreaterZero')]"
                              :disabled="isFormReadonly || isPorcentagemPosicoesEnviadasDisabled"
                              type="number"
                              min="0"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-text-field
                              v-model="editedItem.porcentagem_posicoes_rota"
                              :label="$t('contract.minPercentagePositionsRoute') + ' *'"
                              :rules="isFormReadonly ? [] : [(v) => (!!v && v > 0) || $t('contract.messages.fieldRequiredGreaterZero')]"
                              :disabled="isFormReadonly || isPorcentagemPosicoesRotaDisabled"
                              type="number"
                              min="1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-text-field
                              v-model="editedItem.tempo_entre_posicoes"
                              :label="$t('contract.secondsBetweenPositions') + ' *'"
                              :rules="isFormReadonly ? [] : [(v) => (!!v && v > 0) || $t('contract.messages.fieldRequiredGreaterZero')]"
                              :disabled="isFormReadonly || isTempoEntrePosicoesDisabled"
                              type="number"
                              min="1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-text-field
                              v-model="editedItem.porcentagem_posicoes_tempo"
                              :label="$t('contract.minPercentageMinutesPosition') + ' *'"
                              :rules="isFormReadonly ? [] : [(v) => (!!v && v > 0) || $t('contract.messages.fieldRequiredGreaterZero')]"
                              :disabled="isFormReadonly || isPorcentagemPosicoesTempoDisabled"
                              type="number"
                              min="1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-card>
                              <v-card-title>
                                <span class="headline" style="color: #4a4a4a">{{ $t('contract.associateLines') }}</span>
                              </v-card-title>
                              <v-card-text>
                                <v-list dense class="overflow-y-auto" max-height="250">
                                  <v-list-item-group v-for="(item, i) in filteredLinhas" :key="i" three-line dense>
                                    <v-list-item>
                                      <template v-slot:default="{ active }">
                                        <v-list-item-action>
                                          <v-checkbox :input-value="active" v-model="item.isSelected" :disabled="isFormReadonly"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                          <v-list-item-title>
                                            <span>{{ item.cod_linha }}</span>
                                            <span>{{ item.nome_linha }}</span>
                                          </v-list-item-title>
                                        </v-list-item-content>
                                      </template>
                                    </v-list-item>
                                  </v-list-item-group>
                                </v-list>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" v-if="editedIndex !== -1">
                            <v-card>
                              <v-card-title>
                                <span class="headline" style="color: #4a4a4a">{{ $t('contract.disassociateLines') }}</span>
                              </v-card-title>
                              <v-card-text>
                                <v-list dense class="overflow-y-auto" max-height="250">
                                  <v-list-item-group v-for="(item, i) in filteredLinhasAssociadas" :key="i" three-line dense>
                                    <v-list-item>
                                      <template v-slot:default="{ active }">
                                        <v-list-item-action>
                                          <v-checkbox :input-value="active" v-model="item.isSelected" :disabled="isFormReadonly"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                          <v-list-item-title>
                                            <span>{{ item.cod_linha }}</span>
                                            <span>{{ item.nome_linha }}</span>
                                          </v-list-item-title>
                                        </v-list-item-content>
                                      </template>
                                    </v-list-item>
                                  </v-list-item-group>
                                </v-list>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary darken-1" class="white--text" @click="close">
                    {{ isFormReadonly ? $t('button.close') : $t('button.cancel') }}
                  </v-btn>
                  <v-btn
                    v-if="!isFormReadonly"
                    color="primary darken-1"
                    class="white--text"
                    @click="save"
                  >{{ $t('button.save') }}</v-btn>
                </v-card-actions>
              </v-card>
      </v-dialog>

      <v-container
        v-if="!embedded"
        max-width="100%"
        style="margin-top: 2%"
      >
        <merus-data-table
          :headers="headers"
          :items="contratos"
          :loading="loading"
          :loading-text="$t('contract.loadingContracts')"
          :default-multi-sort="defaultSort"
          @update:displayedItems="displayedItemsForExport = $event"
          cod-tabela="CONTRATOS"
          @update:headers="headers = $event"
        >
          <template v-slot:toolbar>
            <cadastro-toolbar
              :title="$t('contract.title')"
              :token="token"
              :items="displayedItemsForExport !== null ? displayedItemsForExport : contratos"
              :csv-title="$t('contract.csvTitle')"
              :csv-headers="headers"
              :pdf-title="$t('contract.pdfTitle')"
              :pdf-headers="headers"
              :pdf-filename="$t('contract.pdfFilename')"
              hide-search
            >
              <template v-slot:add v-if="canInsert">
                <v-btn color="primary" dark small class="mb-2" fab @click="openNewItem">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
            </cadastro-toolbar>
          </template>
          <template v-slot:item.valor_fixo="{ item }">
        <span>{{ currencyFormatter(item.valor_fixo) }}</span>
      </template>
      <template v-slot:item.valor_variavel="{ item }">
            <span>{{ currencyFormatter(item.valor_variavel) }}</span>
      </template>
      <template v-slot:item.valor_mao_de_obra="{ item }">
        <span>{{ currencyFormatter(item.valor_mao_de_obra) }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
            <v-icon small class="mr-2" color="red" @click="deleteItem(item)"
              :disabled="item.ativo == 0 || !canDelete">mdi-delete</v-icon>
          </template>
        </merus-data-table>
      </v-container>
    </div>
</template>

<script>

import apiController from "@/utils/apiController";
import {
  isFinalidadeValor as ehFinalidadeValorCalculo,
  aceitaComoCalculoValor,
} from "../utils/subsidioFinalidadeCalculo";
import DateUtils from "../utils/dateutils";
import EventBus from "@/utils/eventBus";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import translateDbField from "@/utils/translateDbField";
import { getScopedClienteIdForCreate, shouldLockClienteOnCreate } from "@/utils/sessionCliente";
import {
  mergeSetupCapabilities,
  hasSubsidioCapability,
  isModoSubsidioMexico as checkModoSubsidioMexico,
} from "@/utils/subsidioCapabilities";

export default {
  components: {
    MerusDataTable,
    CadastroToolbar
  },
  props: {
    /** Quando true, só o dialog de contrato (sem tabela) — uso na roteirização. */
    embedded: {
      type: Boolean,
      default: false,
    },
    /** Formulário somente leitura (todos os campos desabilitados, sem salvar). */
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    headers: [],
    displayedItemsForExport: null,
    search: "",
    user: null,
    token: null,
    formValidado: true,
    erro: null,
    showAlert: false,
    mensagemAlerta: "",
    tipoAlerta: "success",
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    showConfirmButton: true,
    messageDismissButton: "",
    messageConfirmButton: "",

    mensagemdialog: "",
    isCodigoDisabled: false,
    loading: false,

    linhas: [],
    filteredLinhas: [],
    linhasAssociadas: [],
    filteredLinhasAssociadas: [],
    contratos: [],
    clientes: [],
    permissoes: [],
    recursos: [],
    empresasPermitidas: [],
    tiposVeiculos: [],
    unidades: [],
    calculosCatalogo: [],
    calculosParametros: {},
    empresas: [],
    dti: null,
    dtf: null,
    datePickerKey: 0,
    textFieldPropsFim: {
      prependInnerIcon: "mdi-calendar",
    },
    timeProps: {
      useSeconds: true,
    },
    editedIndex: -1,
    editedItem: {
      id_contrato: null,
      tipo_contrato: 'OPERACIONAL',
      id_contratos_filhos: [],
      cod_contrato: null,
      descricao: null,
      observacoes: null,
      dt_inicio: null,
      dt_inicio_extenso: null,
      dt_fim: null,
      dt_fim_extenso: null,
      dt_inclusao: null,
      dt_inclusao_extenso: null,
      id_cliente: null,
      nome_cliente: null,
      id_empresa: null,
      razao_social: null,
      valor_km: null,
      valor_fixo: null,
      valor_variavel: null,
      valor_mao_de_obra: null,
      porcentagem_posicoes_enviadas: null,
      porcentagem_posicoes_rota: null,
      porcentagem_posicoes_tempo: null,
      porcentagem_conformidade_distancia: null,
      tempo_entre_posicoes: null,
      tempo_limite_envio: null,
      ativo: null,
      ativo_extenso: null,
      padrao: 0,
      padrao_extenso: null,
      id_tarifa: null,
      id_tarifa_fixa: null,
      id_tarifa_labor: null,
      descricao_tarifa: null,
      id_tipo_veiculo: null,
      descricao_tipo_veiculo: null,
      id_unidades: [],
      id_calculo: null,
      tipo_ciclo_pagamento: 'MENSAL',
      dia_ciclo_pagamento: null,
      dias_ciclo_pagamento: null,
      dt_referencia_ciclo: null,
    },
    deletedItem: {
      id_contrato: null,
      cod_contrato: null,
      descricao: null,
      observacoes: null,
      dt_inicio: null,
      dt_inicio_extenso: null,
      dt_fim: null,
      dt_fim_extenso: null,
      dt_inclusao: null,
      dt_inclusao_extenso: null,
      id_cliente: null,
      nome_cliente: null,
      id_empresa: null,
      razao_social: null,
      valor_km: null,
      valor_fixo: null,
      valor_variavel: null,
      valor_mao_de_obra: null,
      porcentagem_posicoes_enviadas: null,
      porcentagem_posicoes_rota: null,
      porcentagem_posicoes_tempo: null,
      porcentagem_conformidade_distancia: null,
      tempo_entre_posicoes: null,
      tempo_limite_envio: null,
      ativo: null,
      ativo_extenso: null,
      padrao: 0,
      padrao_extenso: null,
      id_tarifa: null,
      id_tarifa_fixa: null,
      id_tarifa_labor: null,
      descricao_tarifa: null,
      id_tipo_veiculo: null,
      descricao_tipo_veiculo: null,
      id_unidades: [],
      id_calculo: null,
    },
    defaultItem: {
      id_contrato: null,
      tipo_contrato: 'OPERACIONAL',
      id_contratos_filhos: [],
      cod_contrato: null,
      descricao: null,
      observacoes: null,
      dt_inicio: null,
      dt_inicio_extenso: null,
      dt_fim: null,
      dt_fim_extenso: null,
      dt_inclusao: null,
      dt_inclusao_extenso: null,
      id_cliente: null,
      nome_cliente: null,
      id_empresa: null,
      razao_social: null,
      valor_km: null,
      valor_fixo: null,
      valor_variavel: null,
      valor_mao_de_obra: null,
      porcentagem_posicoes_enviadas: null,
      porcentagem_posicoes_rota: null,
      porcentagem_posicoes_tempo: null,
      porcentagem_conformidade_distancia: null,
      tempo_entre_posicoes: null,
      tempo_limite_envio: null,
      ativo: null,
      ativo_extenso: null,
      padrao: 0,
      padrao_extenso: null,
      id_tarifa: null,
      id_tarifa_fixa: null,
      id_tarifa_labor: null,
      descricao_tarifa: null,
      id_tipo_veiculo: null,
      descricao_tipo_veiculo: null,
      id_unidades: [],
      id_calculo: null,
      tipo_ciclo_pagamento: 'MENSAL',
      dia_ciclo_pagamento: null,
      dias_ciclo_pagamento: null,
      dt_referencia_ciclo: null,
    },
    isPorcentagemPosicoesEnviadasDisabled: false,
    isPorcentagemPosicoesRotaDisabled: false,
    isPorcentagemPosicoesTempoDisabled: false,
    isTempoEntrePosicoesDisabled: false,
    setup: {},
    tiposTarifas: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
  }),
  computed: {
    showContratoSubsidioRioFields() {
      return hasSubsidioCapability(this.setup, "has_subsidio_contrato_rio");
    },
    showContratoSubsidioTarifaSelect() {
      return hasSubsidioCapability(this.setup, "has_subsidio_contrato_tarifa");
    },
    showContratoSubsidioUnidadesSelects() {
      return hasSubsidioCapability(this.setup, "has_subsidio_contrato_unidades");
    },
    /**
     * A fórmula de valor vale para todos os modos de subsídio que compõem o
     * valor a partir de tarifas — México/MeliBrasil pelos relatórios de total e
     * mensal, Friburgo pelo relatório de frota. Por isso o card não pode
     * depender da capability de unidades, que é só México/MeliBrasil.
     */
    showContratoSubsidioMotorCalculos() {
      return (
        this.showContratoSubsidioTarifaSelect ||
        this.showContratoSubsidioUnidadesSelects
      );
    },
    /** O catálogo é único, mas o vínculo de valor do contrato enxerga só a fatia que lhe cabe. */
    calculosValorCatalogo() {
      return (this.calculosCatalogo || []).filter((c) => aceitaComoCalculoValor(c.finalidade));
    },
    // Lista de 0 ou 1 item: o contrato tem no máximo um cálculo associado, e o
    // template renderiza os parâmetros dele com o mesmo v-for de antes.
    selectedCalculosWithParams() {
      const id = this.editedItem.id_calculo;
      if (id == null) return [];
      return (this.calculosCatalogo || []).filter(
        (c) => c.id_calculo === id && Array.isArray(c.param_keys) && c.param_keys.length > 0
      );
    },
    /**
     * Cálculo de valor associado a este contrato, se houver. Quando
     * existe, ele substitui a composição travada do valor — os campos de valor
     * seguem editáveis porque a fórmula os lê como variáveis de contrato.
     */
    calculoValorContratoAtivo() {
      const id = this.editedItem.id_calculo;
      if (id == null) return null;
      return (
        (this.calculosCatalogo || []).find(
          (c) => c.id_calculo === id && ehFinalidadeValorCalculo(c.finalidade)
        ) || null
      );
    },
    isContratoControle() {
      return this.editedItem.tipo_contrato === 'CONTROLE';
    },
    tarifasFixas() {
      return this.filtrarTarifasPorCategoria('FIXA');
    },
    tarifasVariaveis() {
      return this.filtrarTarifasPorCategoria('VARIAVEL');
    },
    tarifasMaoDeObra() {
      return this.filtrarTarifasPorCategoria('MAO DE OBRA');
    },
    isCicloMensal() {
      return (this.editedItem.tipo_ciclo_pagamento || 'MENSAL') === 'MENSAL';
    },
    isCicloQuinzenal() {
      return this.editedItem.tipo_ciclo_pagamento === 'QUINZENAL';
    },
    isCicloDias() {
      return this.editedItem.tipo_ciclo_pagamento === 'DIAS';
    },
    tipoCicloPagamentoItems() {
      return [
        { value: 'MENSAL', text: this.$t('contract.paymentCycle.monthly') },
        { value: 'QUINZENAL', text: this.$t('contract.paymentCycle.biweekly') },
        { value: 'DIAS', text: this.$t('contract.paymentCycle.customDays') },
      ];
    },
    tipoContratoItems() {
      return [
        { value: 'OPERACIONAL', text: this.$t('contract.typeOperational') },
        { value: 'CONTROLE', text: this.$t('contract.typeControl') },
      ];
    },
    contratosOperacionaisElegiveis() {
      if (!this.contratos || !this.contratos.length) return [];
      const idEmpresa = this.editedItem.id_empresa;
      const idCliente = this.editedItem.id_cliente;
      const filhosAtuais = new Set(this.editedItem.id_contratos_filhos || []);
      return this.contratos.filter((c) => {
        const tipo = c.tipo_contrato || 'OPERACIONAL';
        if (tipo === 'CONTROLE') return false;
        if (filhosAtuais.has(c.id_contrato)) return true;
        if (idEmpresa != null && c.id_empresa !== idEmpresa) return false;
        if (idCliente != null && c.id_cliente != null && c.id_cliente !== idCliente) return false;
        return c.ativo === 1 || c.ativo === true;
      });
    },
    isMexicoSubsidioModo() {
      return checkModoSubsidioMexico(this.setup);
    },
    isFormReadonly() {
      return !!(this.readonly || this.embedded);
    },
    formTitle() {
      if (this.isFormReadonly) {
        return this.$t('routePlanning.sidebar.viewContract');
      }
      return this.editedIndex === -1 ? this.$t('contract.registerContract') : this.$t('contract.editContract');
    },
    clienteCreateRules() {
      // Cliente obrigatório só na criação de contrato de controle (campo não existe no operacional).
      if (this.isFormReadonly || this.editedIndex !== -1 || !this.isContratoControle) return [];
      return [(v) => (v != null && v !== '') || this.$t('contract.messages.clientRequired')];
    },
    textFieldPropsInicio() {
      return {
        prependInnerIcon: "mdi-calendar",
        disabled: this.isFormReadonly,
        rules: this.isFormReadonly
          ? []
          : [(v) => !!v || this.$t('contract.messages.selectDate')],
      };
    },
    textFieldPropsFimComputed() {
      return {
        prependInnerIcon: "mdi-calendar",
        disabled: this.isFormReadonly,
      };
    },
    defaultSort() {
      return [
        { value: 'dt_inicio', options: { text: this.$t('system.labels.decreasing'), value: -1 } }];
    },
    headersGeral() {
      return [
        { text: this.$t('crudUnidades.headers.id'), value: "id_contrato", align: " d-none" },
        { text: this.$tc('clients.self', 1), value: "nome_cliente", sortable: true, filtrable: true },
        { text: this.$tc('company.self', 1), value: "razao_social", sortable: true, filtrable: true },
        { text: this.$t('contract.code'), value: "cod_contrato", sortable: true, filtrable: true },
        ...(this.showContratoSubsidioUnidadesSelects
          ? [{ text: this.$t('contract.type'), value: "tipo_contrato", sortable: true, filtrable: true }]
          : []),
        { text: this.$t('contract.description'), value: "descricao", sortable: true, filtrable: true },
        { text: this.$t('contract.startValidity'), value: "dt_inicio", align: " d-none", sortable: true, filtrable: false },
        { text: this.$t('contract.startValidity'), value: "dt_inicio_extenso", sortable: false, filtrable: true },
        { text: this.$t('contract.endValidity'), value: "dt_fim", align: " d-none", sortable: true, filtrable: false },
        { text: this.$t('contract.endValidity'), value: "dt_fim_extenso", sortable: false, filtrable: true },
        { text: this.$t('contract.inclusion'), value: "dt_inclusao", align: " d-none", sortable: true, filtrable: false },
        { text: this.$t('contract.inclusion'), value: "dt_inclusao_extenso", sortable: false, filtrable: true },
        { text: this.$t('contract.valueFixed'), value: "valor_fixo", sortable: true, filtrable: true },
        { text: this.$t('contract.valueVariable'), value: "valor_variavel", sortable: true, filtrable: true },
        { text: this.$t('contract.valueLabor'), value: "valor_mao_de_obra", sortable: true, filtrable: true },
        { text: this.$t('contract.defaultForReports'), value: "padrao_extenso", sortable: true, filtrable: true },
        { text: this.$t('contract.active'), value: "ativo_extenso", sortable: true, filtrable: true },
        { text: this.$t('contract.valid'), value: "vigente_extenso", sortable: true, filtrable: true }];
    },
    headersRio() {
      return [
        { text: this.$t('contract.table.headers.percentageSent'), value: "porcentagem_posicoes_enviadas", sortable: true, filtrable: true },
        { text: this.$t('contract.table.headers.percentageRoute'), value: "porcentagem_posicoes_rota", sortable: true, filtrable: true },
        { text: this.$t('contract.table.headers.percentageMinutesCovered'), value: "porcentagem_posicoes_tempo", sortable: true, filtrable: true },
        { text: this.$t('contract.table.headers.interval'), value: "tempo_entre_posicoes", sortable: true, filtrable: true },
        { text: this.$t('contract.table.headers.sendLimit'), value: "tempo_limite_envio", sortable: true, filtrable: true }];
    },
    linhasSelected() {
      return this.filteredLinhas.filter((l) => l.isSelected).map((l) => l.id_linha);
    },
    linhasAssociadasSelected() {
      return this.filteredLinhasAssociadas.filter((l) => l.isSelected).map((l) => l.id_linha);
    },
    suppressedHeaderValues() {
      const suppressed = [];
      if (!this.showContratoSubsidioRioFields) {
        suppressed.push(
          'porcentagem_posicoes_enviadas',
          'porcentagem_posicoes_rota',
          'porcentagem_posicoes_tempo',
          'tempo_entre_posicoes',
          'tempo_limite_envio'
        );
      }
      if (!this.showContratoSubsidioUnidadesSelects) {
        suppressed.push('tipo_contrato');
      }
      if (this.isMexicoSubsidioModo) {
        suppressed.push('cod_tarifa');
      } else if (this.showContratoSubsidioTarifaSelect) {
        suppressed.push('descricao_tipo_veiculo');
      } else {
        suppressed.push('cod_tarifa', 'descricao_tarifa', 'descricao_tipo_veiculo');
      }
      return suppressed;
    },
    // Computed property reativa para formatação de moeda
    currencyFormatter() {
      const currencyCode = this.$t('contract.currencyCode') || 'BRL';
      const localeCode = this.$t('contract.localeCode') || 'pt-BR';
      
      return (value) => {
        if (value === null || value === undefined) return '';
        return new Intl.NumberFormat(localeCode, {
          style: 'currency',
          currency: currencyCode,
          maximumFractionDigits: 4
        }).format(value);
      };
    }
  },
  watch: {
    'editedItem.id_calculo'(id) {
      // Garante o bucket de parâmetros mesmo quando o v-autocomplete não dispara
      // @change (seleção por teclado) ou quando o cálculo já vem do backend.
      this.onCalculoContratoChange(id);
    },
    dialog(val) {
      if (val && this.editedIndex === -1) {
        // Resetar id_unidades para array vazio ao abrir dialog para criar novo contrato
        this.$set(this.editedItem, 'tipo_contrato', 'OPERACIONAL');
        this.$set(this.editedItem, 'id_contratos_filhos', []);
        this.$set(this.editedItem, 'id_unidades', []);
        this.$set(this.editedItem, 'padrao', 0);
        // Escopo de cliente (usuários vinculados a um cliente)
        if (this.shouldLockClienteOnCreate()) {
          const scopedId = this.getScopedClienteIdForCreate();
          if (scopedId != null) {
            this.$set(this.editedItem, 'id_cliente', scopedId);
          }
        }
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    '$route.query': {
      deep: true,
      handler(query) {
        if (this.embedded) return;
        if (!query) return;
        if ((query.id_contrato == null || query.id_contrato === '')
          && String(query.tipo_contrato || '').toUpperCase() !== 'CONTROLE') {
          return;
        }
        if (!Array.isArray(this.contratos) || !this.contratos.length) return;
        this.openFromRouteQuery();
      },
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.messageDismissButton = this.$t('button.dismiss');
    this.messageConfirmButton = this.$t('button.confirm');
    this.initialize();
  },
  mounted() {
  },
  methods: {

    getScopedClienteIdForCreate,
    shouldLockClienteOnCreate,
    openNewItem() {
      this.editedIndex = -1;
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.isCodigoDisabled = false;
      this.dialog = true;
    },
    /**
     * Abre o dialog de edição a partir de id/filtros (modo embedded ou deep-link).
     * @param {object|string|number} queryOrId
     */
    async openByQuery(queryOrId) {
      const query = (queryOrId != null && typeof queryOrId === 'object')
        ? queryOrId
        : { id_contrato: queryOrId };

      if (this._setupReady) {
        try {
          await this._setupReady;
        } catch (_) {
          /* segue */
        }
      }
      await this.ensureContratosLoaded();

      let item = null;
      if (query.id_contrato != null && query.id_contrato !== '') {
        item = (this.contratos || []).find((c) => String(c.id_contrato) === String(query.id_contrato));
      }
      if (!item
        && String(query.tipo_contrato || '').toUpperCase() === 'CONTROLE'
        && query.id_cliente != null
        && query.id_cliente !== '') {
        item = await this.resolveControleFromRouteQuery(query);
      }
      if (!item) {
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('contract.messages.notFound'),
        });
        return false;
      }
      await this.editItem(item);
      return true;
    },
    ensureContratosLoaded() {
      if (Array.isArray(this.contratos) && this.contratos.length) {
        return Promise.resolve();
      }
      if (this._contratosReady) return this._contratosReady;
      return this.populaContratos();
    },
    contratoFilhoLabel(c) {
      if (!c) return '';
      return `${c.cod_contrato || c.id_contrato} — ${c.descricao || ''}`;
    },
    normalizeCicloPagamentoFields(item) {
      if (!item) return;
      // Friburgo (e modos sem unidades): sempre mês calendário.
      if (!this.showContratoSubsidioUnidadesSelects) {
        this.$set(item, 'tipo_ciclo_pagamento', 'MENSAL');
        this.$set(item, 'dia_ciclo_pagamento', null);
        this.$set(item, 'dias_ciclo_pagamento', null);
        this.$set(item, 'dt_referencia_ciclo', null);
        return;
      }
      if (!item.tipo_ciclo_pagamento) {
        this.$set(item, 'tipo_ciclo_pagamento', 'MENSAL');
      }
      if (item.dt_referencia_ciclo && String(item.dt_referencia_ciclo).length > 10) {
        this.$set(item, 'dt_referencia_ciclo', String(item.dt_referencia_ciclo).substring(0, 10));
      }
      if (item.tipo_ciclo_pagamento === 'QUINZENAL') {
        this.$set(item, 'dia_ciclo_pagamento', null);
        this.$set(item, 'dias_ciclo_pagamento', null);
      } else if (item.tipo_ciclo_pagamento === 'DIAS') {
        this.$set(item, 'dia_ciclo_pagamento', null);
      } else if (item.tipo_ciclo_pagamento === 'MENSAL') {
        this.$set(item, 'dt_referencia_ciclo', null);
        this.$set(item, 'dias_ciclo_pagamento', null);
      }
    },
    logout() {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("api");
      var id = window.setTimeout(function () { }, 0);
      while (id--) {
        window.clearTimeout(id); // will do nothing if no timeout with id is present
      }
      this.$router.push({ path: "/" });
    },
    initialize() {
      this.populaSetup();
      this.populaPermissoes();
      this.populaRecursos();
      this.populaContratos();
      this.populaClientes();
      this.populaCalculosCatalogo();
      this.populaTiposTarifas();
      this.populaTiposVeiculos();
      this.populaUnidades();
    },
    async populaCalculosCatalogo() {
      // O guard depende de `setup`, que chega por populaSetup(); sem esperar,
      // a capability ainda é falsa aqui e o catálogo nunca carregaria.
      if (this._setupReady) {
        try {
          await this._setupReady;
        } catch (_) {
          /* segue com o que houver */
        }
      }
      if (!this.showContratoSubsidioMotorCalculos) return;
      apiController.request(apiController.endpoints.subsidioMotorCalculos, {
        silent: true,
        onSuccess: (response) => {
          const list = Array.isArray(response.data) ? response.data : [];
          this.calculosCatalogo = list.map((c) => ({
            id_calculo: c.id_calculo,
            codigo: c.codigo,
            descricao: c.descricao,
            tipo_resultado: c.tipo_resultado,
            finalidade: c.finalidade || 'GERAL',
            id_agrupamento: c.id_agrupamento,
            param_keys: Array.isArray(c.param_keys) ? c.param_keys : [],
          }));
        },
      });
    },
    /** Exposto como método porque o template precisa dele. */
    isFinalidadeValor(finalidade) {
      return ehFinalidadeValorCalculo(finalidade);
    },
    calculoCatalogoLabel(c) {
      if (!c) return '';
      return `${c.codigo || c.id_calculo} — ${c.descricao || ''}`;
    },
    calculoParamLabel(calc, key) {
      return `${calc.codigo}: ${this.$t('subsidyMotorContract.calculationParam', { key })}`;
    },
    ensureCalculoParametros(idCalculo, keys, existing) {
      if (!this.calculosParametros[idCalculo]) {
        this.$set(this.calculosParametros, idCalculo, {});
      }
      const bucket = this.calculosParametros[idCalculo];
      (keys || []).forEach((key) => {
        if (bucket[key] == null && existing && existing[key] != null) {
          this.$set(bucket, key, existing[key]);
        } else if (bucket[key] == null) {
          this.$set(bucket, key, null);
        }
      });
    },
    onCalculoContratoChange(id) {
      if (id == null) return;
      const calc = (this.calculosCatalogo || []).find((c) => c.id_calculo === id);
      if (calc) this.ensureCalculoParametros(calc.id_calculo, calc.param_keys);
    },
    populaCalculosAssociados() {
      this.fetchCalculosAssociados(this.editedItem.id_contrato);
    },
    async fetchCalculosAssociados(idContrato) {
      if (!this.showContratoSubsidioMotorCalculos || !idContrato) return;
      try {
        const response = await apiController.request(apiController.endpoints.subsidioMotorGetCalculosassociadoscontrato, {
          params: { idcontrato: idContrato },
          silent: true,
        });
        if (response.data && Array.isArray(response.data)) {
          // Bases antigas podem ter mais de uma associação; a tela assume a
          // primeira (menor ordem) e o próximo salvamento normaliza o registro.
          const associado = response.data[0] || null;
          this.$set(
            this.editedItem,
            'id_calculo',
            associado ? associado.id_calculo : null,
          );
          if (associado) {
            const catalogo = (this.calculosCatalogo || []).find(
              (cc) => cc.id_calculo === associado.id_calculo
            );
            this.ensureCalculoParametros(
              associado.id_calculo,
              (catalogo || {}).param_keys,
              associado.parametros
            );
          }
        }
      } catch (_) {
        /* mantém cálculos vazios */
      }
    },
    async saveCalculosContrato(idContrato, idCalculo) {
      if (!this.showContratoSubsidioMotorCalculos || !idContrato) return;
      // Um contrato tem no máximo um cálculo: a lista enviada é vazia (nenhum
      // selecionado) ou tem exatamente um item.
      const calculos = [];
      if (idCalculo != null) {
        const keys = ((this.calculosCatalogo || []).find((c) => c.id_calculo === idCalculo) || {}).param_keys || [];
        let parametros = null;
        if (keys.length) {
          parametros = {};
          keys.forEach((key) => {
            const bucket = this.calculosParametros[idCalculo] || {};
            parametros[key] = bucket[key];
          });
        }
        calculos.push({ id_calculo: idCalculo, parametros, ordem: 0 });
      }
      try {
        await apiController.request(apiController.endpoints.subsidioMotorSetcalculoscontrato, {
          data: { id_contrato: idContrato, calculos },
          silent: true,
        });
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
        throw e;
      }
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          const list = Array.isArray(response.data) ? response.data : [];
          this.clientes = list
            .filter((c) => c.ativo === 1 || c.ativo === true || c.ativo == null)
            .sort((a, b) => String(a.nome_cliente || "").localeCompare(String(b.nome_cliente || ""), undefined, { sensitivity: "base" }));
        },
      });
    },
    populaSetup() {
      this._setupReady = apiController.request(apiController.endpoints.getallParametrossetup, {
        onSuccess: (response) => {
          this.setup = mergeSetupCapabilities(response.data[0] || {});
          this.populaCalculosCatalogo();
        },
      }).catch(() => {});
    },
    populaTiposTarifas() {
      apiController.request(apiController.endpoints.getallTipostarifas, {
        onSuccess: (response) => {
          this.tiposTarifas = response.data;
        },
      });
    },
      populaEmpresasPermitidas() {
        this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
          return { id_empresa: rec.id_empresa, razao_social: rec.razao_social };
        });
      },
    populaTiposVeiculos() {
      apiController.request(apiController.endpoints.getallTiposveiculos, {
        onSuccess: (response) => {
          this.tiposVeiculos = response.data.map((tipoVeiculo) => {
            const translated = translateDbField(
              tipoVeiculo.translation_key,
              tipoVeiculo.descricao_tipo_veiculo
            );
            return {
              ...tipoVeiculo,
              descricao_tipo_veiculo: translated
            };
          });
        },
      });
    },
    populaUnidades() {
      apiController.request(apiController.endpoints.getallUnidades, {
        onSuccess: (response) => {
          const ativas = response.data.filter((u) => u.ativa == 1);
          this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...ativas];
        },
      });
    },
    populaPermissoes() {
      apiController.request(apiController.endpoints.getPermissoesusuario, {
        params: { id: this.user.id_usuario },
        onSuccess: (response) => {
          this.permissoes = response.data;
        },
      });
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.populaEmpresasPermitidas();
            this.populaTiposVeiculos();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/subsidio/updatecontratosubsidio");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/subsidio/insertcontratosubsidio");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/subsidio/deletecontratosubsidio");
            this.populaEmpresasPermitidas();
            this.populaTiposVeiculos();
          },
        });
      }
    },
      // populaLinhas() {
      //   apiController.request(apiController.endpoints.subsidioGetLinhassemcontrato, {
      //     onSuccess: (response) => {
      //       this.linhas = response.data.filter((l) => this.empresasPermitidas.findIndex((e) => e.id_empresa === l.id_empresa) !== -1);
      //       this.filteredLinhas = this.linhas.map((l) => {
      //         l.isSelected = false;
      //         return l;
      //       });
      //     },
    populaLinhasAssociadas() {
      if (!this.showContratoSubsidioRioFields) {
        this.linhasAssociadas = [];
        this.filteredLinhasAssociadas = [];
        return;
      }
      apiController.request(apiController.endpoints.subsidioGetLinhasassociadascontrato, {
        params: { id: this.editedItem.id_contrato },
        onSuccess: (response) => {
          this.linhasAssociadas = response.data;
          this.filteredLinhasAssociadas = this.linhasAssociadas.map((l) => {
            l.isSelected = false;
            return l;
          });
          if (!this.showContratoSubsidioUnidadesSelects) {
            this.dialog = true;
          }
        },
        onError: () => {
          if (!this.showContratoSubsidioUnidadesSelects) {
            this.dialog = true;
          }
        },
      });
    },
    populaUnidadesAssociadas() {
      if (!this.showContratoSubsidioUnidadesSelects) {
        this.dialog = true;
        return;
      }
      this.fetchUnidadesAssociadas(this.editedItem.id_contrato)
        .finally(() => {
          this.dialog = true;
        });
    },
    async fetchUnidadesAssociadas(idContrato) {
      if (!idContrato) return;
      try {
        const response = await apiController.request(apiController.endpoints.subsidioGetUnidadesassociadascontrato, {
          params: { idcontrato: idContrato },
          silent: true,
        });
        if (response.data && Array.isArray(response.data)) {
          this.$set(this.editedItem, 'id_unidades', response.data.map((u) => u.id_unidade));
        }
      } catch (_) {
        /* mantém id_unidades já inicializado */
      }
    },
    populaContratos() {
      this.loading = true;
      this._contratosReady = apiController.request(apiController.endpoints.subsidioGetallContratossubsidio, {
        onSuccess: (response) => {
          this.contratos = Array.isArray(response.data) ? response.data : [];
          this.loading = false;
          if (!this.embedded) {
            this.openFromRouteQuery();
          }
        },
        onError: () => {
          this.loading = false;
        },
      }).catch(() => {
        this.loading = false;
      });
      return this._contratosReady;
    },
    async openFromRouteQuery() {
      if (this.embedded) return;
      const q = this.$route && this.$route.query ? this.$route.query : null;
      if (!q) return;

      let item = null;
      if (q.id_contrato != null && q.id_contrato !== '') {
        item = (this.contratos || []).find((c) => String(c.id_contrato) === String(q.id_contrato));
      }
      if (!item
        && String(q.tipo_contrato || '').toUpperCase() === 'CONTROLE'
        && q.id_cliente != null
        && q.id_cliente !== '') {
        item = await this.resolveControleFromRouteQuery(q);
      }
      if (!item) return;

      if (this._setupReady) {
        try {
          await this._setupReady;
        } catch (_) {
          /* segue com setup atual */
        }
      }

      // Limpa a query só depois de resolver o item, para não perder o deep-link.
      try {
        await this.$router.replace({ path: '/contratos', query: {} });
      } catch (_) {
        /* NavigationDuplicated / cancelado */
      }
      await this.$nextTick();
      await this.editItem(item);
    },
    async resolveControleFromRouteQuery(q) {
      const candidates = (this.contratos || []).filter((c) => {
        if (!c || Number(c.ativo) !== 1) return false;
        if ((c.tipo_contrato || 'OPERACIONAL') !== 'CONTROLE') return false;
        if (String(c.id_cliente) !== String(q.id_cliente)) return false;
        if (q.id_empresa != null && q.id_empresa !== '' && String(c.id_empresa) !== String(q.id_empresa)) {
          return false;
        }
        return true;
      });
      if (!candidates.length) return null;
      if (candidates.length === 1) return candidates[0];

      const idUnidade = q.id_unidade;
      if (idUnidade == null || idUnidade === '') return candidates[0];

      for (let i = 0; i < candidates.length; i += 1) {
        const c = candidates[i];
        try {
          const response = await apiController.request(apiController.endpoints.subsidioGetUnidadesassociadascontrato, {
            params: { idcontrato: c.id_contrato },
            silent: true,
          });
          const units = Array.isArray(response.data) ? response.data : [];
          if (units.some((u) => String(u.id_unidade) === String(idUnidade))) {
            return c;
          }
        } catch (_) {
          /* tenta o próximo */
        }
      }
      return candidates[0];
    },
      async editItem(item) {
        const byId = (this.contratos || []).findIndex(
          (c) => c && item && String(c.id_contrato) === String(item.id_contrato),
        );
        this.editedIndex = byId >= 0 ? byId : this.contratos.indexOf(item);
        this.editedItem = Object.assign({}, item);
        if (!this.editedItem.tipo_contrato) {
          this.editedItem.tipo_contrato = 'OPERACIONAL';
        }
        this.editedItem.padrao =
          this.editedItem.padrao === true ||
          this.editedItem.padrao === 1 ||
          this.editedItem.padrao === '1'
            ? 1
            : 0;
        this.normalizeCicloPagamentoFields(this.editedItem);
        this.editedItem.id_unidades = [];
        this.editedItem.id_calculo = null;
        this.calculosParametros = {};
        this.editedItem.id_contratos_filhos = [];
        this.normalizeCicloPagamentoFields(this.editedItem);
        this.dti = this.editedItem.dt_inicio_extenso;
        this.dtf = this.editedItem.dt_fim_extenso;
        if (this.showContratoSubsidioRioFields) {
          this.populaLinhasAssociadas();
        }
        // Cálculos existem em todos os modos que compõem valor por tarifa
        // (inclusive Friburgo), então o carregamento fica fora do bloco de
        // unidades, que é só México/MeliBrasil.
        if (this.showContratoSubsidioMotorCalculos) {
          this.populaCalculosAssociados();
        }
        if (this.showContratoSubsidioUnidadesSelects) {
          if ((this.editedItem.tipo_contrato || 'OPERACIONAL') === 'CONTROLE') {
            this.$set(this.editedItem, 'id_contratos_filhos', []);
            // Abrir o dialog só depois de filhos + unidades,
            // senão um save precoce apaga unidades (deleteAll com lista vazia).
            try {
              await Promise.all([
                this.fetchContratosConsolidados(this.editedItem.id_contrato),
                this.fetchUnidadesAssociadas(this.editedItem.id_contrato),
              ]);
            } catch (_) {
              /* abre mesmo assim para permitir edição */
            }
            this.dialog = true;
          } else {
            this.populaGrandezasAssociadas();
            this.populaCalculosAssociados();
            this.populaUnidadesAssociadas();
          }
        } else {
          this.dialog = true;
        }
      },
    populaContratosConsolidados() {
      this.fetchContratosConsolidados(this.editedItem.id_contrato)
        .finally(() => {
          this.dialog = true;
        });
    },
    async fetchContratosConsolidados(idContrato) {
      if (!idContrato) return;
      try {
        const response = await apiController.request(apiController.endpoints.subsidioGetContratosconsolidados, {
          params: { id: idContrato },
          silent: true,
        });
        if (response.data && Array.isArray(response.data)) {
          this.$set(
            this.editedItem,
            'id_contratos_filhos',
            response.data.map((c) => c.id_contrato),
          );
        }
      } catch (_) {
        /* mantém filhos vazios */
      }
    },
    async setContratosConsolidados(idContratoControle, idsOperacionais) {
      const resp = await apiController.request(apiController.endpoints.subsidioSetcontratosconsolidados, {
        data: {
          id_contrato_controle: idContratoControle,
          ids_operacionais: idsOperacionais || [],
        },
        silent: true,
      });
      if (resp.data && resp.data.erro) {
        const err = new Error(resp.data.mensagem || 'Erro ao vincular contratos');
        throw err;
      }
      return resp;
    },
    populaGrandezasAssociadas() {
      this.fetchGrandezasAssociadas(this.editedItem.id_contrato);
    },
    async fetchGrandezasAssociadas(idContrato) {
      if (!this.showContratoSubsidioMotorGrandezas || !idContrato) return;
      try {
        const response = await apiController.request(apiController.endpoints.subsidioMotorGetGrandezasContrato, {
          params: { idcontrato: idContrato },
          silent: true,
        });
        if (response.data && Array.isArray(response.data)) {
          this.$set(
            this.editedItem,
            'id_grandezas',
            response.data.map((g) => g.id_grandeza),
          );
        }
      } catch (_) {
        /* mantém grandezas vazias */
      }
    },
      deleteItem(item) {
        this.deletedItem = Object.assign({}, item);
        this.mensagemdialog = this.$t('contract.messages.confirmDeactivation') + " " + item.cod_contrato + " ?";
        this.showConfirmButton = true;
        this.messageDismissButton = this.$t('button.dismiss');
        this.messageConfirmButton = this.$t('button.confirm');
        this.confirmDialog = true;
      },
      async confirm() {
        if (this.deletedItem.id_contrato) {
          this.deleteFromDatabase();
        } else {
          let contrato = this.contratos.find((c) =>
            this.contratoCompartilhaTarifa(c, this.editedItem) &&
            (c.dt_fim == null || c.dt_fim >= this.dti)
          );
          if (contrato) {
            contrato.dt_fim = this.editedItem.dt_inicio;
            contrato.dt_inicio = DateUtils.getDateSQLFormatted(new Date(contrato.dt_inicio));
            const update = await this.atualizarContrato(contrato);
            if (!update.data.erro) {
              const insert = await this.inserirContrato(this.buildContratoApiPayload());
              this.updateTable(insert);
            } else {
              this.updateTable(update);
            }
          }
        }
        this.showConfirmButton = false;
        this.mensagemdialog = "";
        this.confirmDialog = false;
      },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;

      apiController.request(apiController.endpoints.subsidioDeleteContratosubsidio, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response);
        },
      });
    },
      close() {
        this.dialog = false;
        if (this.$refs.form && typeof this.$refs.form.resetValidation === 'function') {
          this.$refs.form.resetValidation();
        }
        this.$nextTick(() => {
          // Deep copy para evitar problemas com arrays
          this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
          this.editedIndex = -1;
          this.isCodigoDisabled = false;
          this.dti = null;
          this.dtf = null;
          this.datePickerKey += 1;
        });
      },
    async insertUnidades(idContrato, unidades) {
      if (!this.showContratoSubsidioUnidadesSelects) return;
      if (unidades.length > 0 && idContrato) {
        const dados = unidades.map((idUnidade) => [idContrato, idUnidade]);

        try {
          await apiController.request(apiController.endpoints.subsidioInsertUnidadescontratossubsidio, {
            data: dados,
            silent: true,
          });
        } catch (e) {
          EventBus.$emit('show-error', { error: e });
        }
      }
    },
    async saveGrandezasContrato(idContrato, idGrandezas) {
      if (!this.showContratoSubsidioMotorGrandezas || !idContrato) return;
      const grandezas = (idGrandezas || []).map((idGrandeza, idx) => ({
        id_grandeza: idGrandeza,
        ordem: idx,
      }));
      try {
        await apiController.request(apiController.endpoints.subsidioMotorSetGrandezasContrato, {
          data: { id_contrato: idContrato, grandezas },
          silent: true,
        });
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
        throw e;
      }
    },
    async deleteAllUnidadesContrato(idContrato) {
      if (!this.showContratoSubsidioUnidadesSelects) return;
      return apiController.request(apiController.endpoints.subsidioDeleteAllunidadescontrato, {
        data: { id_contrato: idContrato },
        silent: true,
      });
    },
    saveLinhas(resp) {
      if (!this.showContratoSubsidioRioFields) {
        this.updateTable(resp);
        return;
      }
      let temp = this.linhasSelected.map((l) =>{
        return [resp.data.insertId, l];
      });

      if (temp.length > 0) {
        apiController.request(apiController.endpoints.subsidioInsertLinhascontratosubsidio, {
          data: temp,
          onSuccess: (response) => {
            this.updateTable(response);
          },
        });
      } else {
        this.updateTable(resp);
      }
    },
    desassociaLinhas(resp) {
      if (!this.showContratoSubsidioRioFields) {
        this.updateTable(resp);
        return;
      }
      let temp = this.linhasAssociadasSelected

      if (temp.length > 0) {
        apiController.request(apiController.endpoints.desassociaLinhasbulk, {
          data: temp,
          onSuccess: (response) => {
            this.updateTable(response);
          },
        });
      } else {
        this.updateTable(resp);
      }
    },
    contratoExiste() {
      if (this.showContratoSubsidioUnidadesSelects || this.isContratoControle) {
        return false;
      }
      return this.contratos.findIndex((c) =>
        c.id_contrato !== this.editedItem.id_contrato &&
        this.contratoCompartilhaTarifa(c, this.editedItem) &&
        (c.dt_fim == null || c.dt_fim >= this.dti)
      ) !== -1;
    },
    idsTarifasContrato(item) {
      return [item && item.id_tarifa, item && item.id_tarifa_fixa, item && item.id_tarifa_labor]
        .filter((id) => id != null && id !== '')
        .map((id) => Number(id));
    },
    contratoCompartilhaTarifa(a, b) {
      const idsA = this.idsTarifasContrato(a);
      const idsB = this.idsTarifasContrato(b);
      if (!idsA.length || !idsB.length) return false;
      return idsB.some((id) => idsA.includes(id));
    },
    /**
     * Cálculo de valor associado à tarifa escolhida naquele campo do contrato,
     * ou null. Quando existe, o motor usa a fórmula no lugar do valor digitado.
     */
    calculoDaTarifa(campoTarifa) {
      const idTarifa = this.editedItem ? this.editedItem[campoTarifa] : null;
      if (idTarifa == null) return null;
      const list = Array.isArray(this.tiposTarifas) ? this.tiposTarifas : [];
      const tarifa = list.find((t) => t.id_tarifa === idTarifa);
      return tarifa && tarifa.id_calculo_valor ? tarifa : null;
    },
    hintValorCalculado(campoTarifa) {
      const tarifa = this.calculoDaTarifa(campoTarifa);
      if (!tarifa) return '';
      return this.$t('contract.valueFromCalculation', { code: tarifa.calculo_codigo });
    },
    filtrarTarifasPorCategoria(codCategoria) {
      const mapIds = { FIXA: 1, VARIAVEL: 2, 'MAO DE OBRA': 3 };
      const cod = String(codCategoria || '').toUpperCase();
      const idCat = mapIds[cod];
      const list = Array.isArray(this.tiposTarifas) ? this.tiposTarifas : [];
      return list.filter((t) => {
        if (t.cod_categoria) {
          return String(t.cod_categoria).toUpperCase() === cod;
        }
        return idCat != null && Number(t.id_categoria) === idCat;
      });
    },
    async save() {
      if (this.isFormReadonly) return;
      this.$refs.form.validate();
      if (this.formValidado) {
        this.editedItem.dt_inicio = DateUtils.getDateSQLFormatted(this.dti);
        this.editedItem.dt_fim = DateUtils.getDateSQLFormatted(this.dtf);
        this.normalizeCicloPagamentoFields(this.editedItem);

        if (this.contratoExiste()) {
          this.mensagemdialog = this.$t('contract.messages.contractExists');
          this.showConfirmButton = true;
          this.messageDismissButton = this.$t('button.dismiss');
          this.messageConfirmButton = this.$t('button.confirm');
          this.confirmDialog = true;
          return;
        }

        const isControle = this.isContratoControle;

        if (this.editedIndex == -1) {
          const unidadesSelecionadas = [...(this.editedItem.id_unidades || [])];
          const calculoSelecionado = this.editedItem.id_calculo != null ? this.editedItem.id_calculo : null;
          const filhosSelecionados = [...(this.editedItem.id_contratos_filhos || [])];

          const response = await this.inserirContrato(this.buildContratoApiPayload());
          if (!response.data.erro) {
            const idContrato = response.data.insertId;
            if (isControle) {
              try {
                await this.setContratosConsolidados(idContrato, filhosSelecionados);
                await this.deleteAllUnidadesContrato(idContrato);
                if (unidadesSelecionadas.length > 0) {
                  await this.insertUnidades(idContrato, unidadesSelecionadas);
                }
                await this.saveCalculosContrato(idContrato, calculoSelecionado);
              } catch (e) {
                EventBus.$emit('show-error', { error: e });
                return;
              }
            } else {
              this.saveLinhas(response);
              if (unidadesSelecionadas.length > 0) {
                await this.insertUnidades(idContrato, unidadesSelecionadas);
              }
              await this.saveCalculosContrato(idContrato, calculoSelecionado);
            }
            this.close();
            this.initialize();
          } else {
            this.updateTable(response);
          }
        } else {
          const idContrato = this.editedItem.id_contrato;
          const unidadesSelecionadas = [...(this.editedItem.id_unidades || [])];
          const calculoSelecionado = this.editedItem.id_calculo != null ? this.editedItem.id_calculo : null;
          const filhosSelecionados = [...(this.editedItem.id_contratos_filhos || [])];

          const response = await this.atualizarContrato(this.buildContratoApiPayload());
          if (!response.data.erro) {
            if (isControle) {
              try {
                await this.setContratosConsolidados(idContrato, filhosSelecionados);
                await this.deleteAllUnidadesContrato(idContrato);
                if (unidadesSelecionadas.length > 0) {
                  await this.insertUnidades(idContrato, unidadesSelecionadas);
                }
                await this.saveCalculosContrato(idContrato, calculoSelecionado);
              } catch (e) {
                EventBus.$emit('show-error', { error: e });
                return;
              }
            } else {
              this.saveLinhas({ data: { insertId: idContrato, erro: false } });
              this.desassociaLinhas(response);
              await this.deleteAllUnidadesContrato(idContrato);
              if (unidadesSelecionadas.length > 0) {
                await this.insertUnidades(idContrato, unidadesSelecionadas);
              }
              await this.saveCalculosContrato(idContrato, calculoSelecionado);
            }
            this.close();
            this.initialize();
          } else {
            this.updateTable(response);
          }
        }
      }
    },
    buildContratoApiPayload() {
      this.normalizeCicloPagamentoFields(this.editedItem);
      const p = Object.assign({}, this.editedItem);
      delete p.id_contratos_filhos;
      delete p.qtd_filhos;
      delete p.dt_inicio_extenso;
      delete p.dt_fim_extenso;
      delete p.dt_inclusao_extenso;
      delete p.ativo_extenso;
      delete p.padrao_extenso;
      delete p.vigente;
      delete p.vigente_extenso;
      delete p.nome_cliente;
      delete p.razao_social;
      delete p.descricao_tarifa;
      delete p.descricao_tarifa_fixa;
      delete p.descricao_tarifa_labor;
      delete p.descricao_tipo_veiculo;
      if (!this.showContratoSubsidioUnidadesSelects) {
        p.tipo_ciclo_pagamento = 'MENSAL';
        p.dia_ciclo_pagamento = null;
        p.dias_ciclo_pagamento = null;
        p.dt_referencia_ciclo = null;
      }
      if ((p.tipo_contrato || 'OPERACIONAL') === 'CONTROLE') {
        p.valor_km = null;
        p.valor_fixo = null;
        p.valor_variavel = null;
        p.valor_mao_de_obra = null;
        p.id_tarifa = null;
        p.id_tarifa_fixa = null;
        p.id_tarifa_labor = null;
        p.id_tipo_veiculo = null;
        p.padrao = 0;
      } else {
        p.id_cliente = null;
        p.padrao = p.padrao === true || p.padrao === 1 || p.padrao === '1' ? 1 : 0;
        if (p.valor_variavel != null && p.valor_variavel !== '') {
          p.valor_km = p.valor_variavel;
        }
      }
      return p;
    },
    async inserirContrato(contrato) {
      this.operacao = 0;
      return apiController.request(apiController.endpoints.subsidioInsertContratosubsidio, {
        data: contrato,
        silent: true,
      });
    },
    async atualizarContrato(contrato) {
      this.operacao = 1;
      return apiController.request(apiController.endpoints.subsidioUpdateContratosubsidio, {
        data: contrato,
        silent: true,
      });
    },
      updateTable(response) {
        if (response.data.erro) {
          if (this.operacao == 0) {
            EventBus.$emit('show-alert', { mensagem: this.$t('contract.messages.error.insert') +  response.data.mensagem, tipo: 'error' });
          } else {
            if (this.operacao == 1) {
              EventBus.$emit('show-alert', { mensagem: this.$t('contract.messages.error.update') + response.data.mensagem, tipo: 'error' });
            } else {
              EventBus.$emit('show-alert', { mensagem: this.$t('contract.messages.error.delete') + response.data.mensagem, tipo: 'error' });
            }
          }
        } else {
          if (this.operacao == 0) {
            EventBus.$emit('show-alert', { mensagem: this.$t('contract.messages.success.insert'), tipo: 'success' });
          } else {
            if (this.operacao == 1) {
              EventBus.$emit('show-alert', { mensagem: this.$t('contract.messages.success.update'), tipo: 'success' });
            } else {
              EventBus.$emit('show-alert', { mensagem: this.$t('contract.messages.success.delete'), tipo: 'success' });
            }
          }
        }
        if (this.operacao !== 2) {
          this.close();
        }
        this.initialize();
    }
  },
};
</script>